import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

function SelectedUserChips({ users, onRemove }) {
	if (!users?.length) {
		return null;
	}

	return (
		<div className="add-member-wizard__chips">
			{users.map((user) => (
				<div key={user.email} className="add-member-wizard__chip">
					<span>{user.firstName} {user.lastName}</span>
					<button
						type="button"
						className="add-member-wizard__chip-rm"
						onClick={() => onRemove(user.email)}
						aria-label="remove"
					>
						<FontAwesomeIcon icon={faTimes} />
					</button>
				</div>
			))}
		</div>
	);
}

export default SelectedUserChips;
